import { InMemoryCache } from '@apollo/client';

export const createApolloCache = () =>
  new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // A project already loaded by a list opens at once; the server's
          // answer follows (cache-and-network).
          project: {
            read: (existingProject, { args, toReference }) =>
              existingProject ??
              toReference({ __typename: 'Project', id: args?.id }),
          },
        },
      },
    },
  });
